module.exports = "/_next/static/images/OgGrowthMasters-2a58cb594dc55ab300b61bd9183e11a0.png";